































































































































































































































































































































































































































































import Vue from 'vue'
import { getDetailedPatientByIdQuery, MedicalInfo, updatePatientQuery } from '@/jsonapi/DetailedPatient'
import { toReadableTime, toTimestamp } from '@/utils/time'
import SixMinuteWalks from '@/components/patients-detail/SixMinuteWalks.vue'
import LungCapacities from '@/components/patients-detail/LungCapacities.vue'
import InhaledMedication from '@/components/patients-detail/InhaledMedication.vue'
import { FlatDetailedPatient } from '@/store/modules/detailed-patient/getters'
import AssignPccPatientMatchDialog from '@/components/dialog/AssignPccPatientMatchDialog.vue'

export default Vue.extend({
  components: {
    AssignPccPatientMatchDialog,
    SixMinuteWalks,
    LungCapacities,
    InhaledMedication,
  },
  data: function() {
    return {
      patient: null as any,
      loading: true as boolean,
      saving: false as boolean,
      error: false as boolean,
      errorMessage: '' as string,
      erLastDateMenu: false as boolean,
      erLastDate: '' as string,
      showAssignPccPatientMatchDialog: false as boolean,
    }
  },
  computed: {
    patientId(): string {
      return this.$route.params.patient_id
    },
  },
  async mounted(): Promise<void> {
    await this.initComponent({ patientId: this.$route.params.patient_id, path: this.$route.path })
  },
  async beforeRouteUpdate(to, from, next): Promise<void> {
    await this.initComponent({ patientId: to.params.patient_id, path: to.path })
    next()
  },
  methods: {
    async initComponent({ patientId, path }): Promise<void> {
      this.patient = null
      this.loading = true
      this.saving = false
      this.error = false
      this.errorMessage = ''
      this.erLastDateMenu = false
      this.erLastDate = ''
      this.showAssignPccPatientMatchDialog = false

      const results = await getDetailedPatientByIdQuery(patientId)

      if (results.length === 0) {
        await this.$router.replace({ name: '404', params: { '0': path } })
        return
      }
      this.initializeData(results[0])

      this.loading = false
    },
    initializeData(data): void {
      const id = data.id
      const attributes = data.attributes
      const firstName = data.attributes.firstName || ''
      const lastName = data.attributes.lastName || ''
      const fullName = `${firstName} ${lastName}`.trim() || id
      const patientPhone = data.attributes.phone || ''
      const address = attributes.address || {}
      const medicalInfo = attributes.medicalInfo || { sixMinutesWalks: [], lungCapacities: [], erVisit: [{}] }

      this.patient = { id, ...data.attributes, fullName, patientPhone, address, medicalInfo }
      const thisMedicalInfo: MedicalInfo | undefined = this.patient.medicalInfo

      if (thisMedicalInfo && thisMedicalInfo.erVisit && thisMedicalInfo.erVisit.length > 0) {
        const erAdmission = thisMedicalInfo.erVisit[0].lastAdmission
        if (erAdmission) {
          this.erLastDate = toReadableTime({
            timestamp: erAdmission,
            format: 'YYYY-MM-DD',
            timezone: this.patient.timezone,
          })
        }
      }
    },
    handleErLastDate(): void {
      const medicalInfo: MedicalInfo | undefined = this.patient.medicalInfo

      if (medicalInfo && medicalInfo.erVisit && medicalInfo.erVisit.length > 0) {
        medicalInfo.erVisit[0].lastAdmission = toTimestamp(this.erLastDate, this.patient.timezone)
        // console.log(medicalInfo.erVisit[0].lastAdmission)
      }
      this.erLastDateMenu = false
    },
    careGiverText(val: any): string {
      return `${val.firstName} ${val.lastName}`
    },
    pccPatientText(val: any): string {
      let location =
        val.floorDesc || val.roomDesc || val.bedDesc
          ? `${val.floorDesc} ${val.roomDesc} - ${val.bedDesc}`
          : '(unknown location)'
      return `${location}: ${val.firstName} ${val.lastName} (${val.pccPatientId})`.trim()
    },
    suggestedPccPatient() {
      // if the API gave us only 1 patient
      if (this.patient.sitePccPatients.length === 1) {
        return this.patient.sitePccPatients[0]
      }
      let pccPatientsInThisRoom = this.patient.sitePccPatients.filter(
        pccPatient => pccPatient.roomDesc == this.patient.roomNumber
      )
      if (pccPatientsInThisRoom.length === 1) {
        return pccPatientsInThisRoom[0]
      }
      let pccPatientMatchingBed = pccPatientsInThisRoom.filter(
        pccPatient => pccPatient.bedDesc == this.patient.bedNumber
      )
      if (pccPatientMatchingBed.length === 1) {
        return pccPatientMatchingBed[0]
      }

      // now try by last name
      let pccPatientsMatchingLastName = this.patient.sitePccPatients.filter(
        pccPatient => pccPatient.lastName == this.patient.lastName
      )
      if (pccPatientsMatchingLastName.length === 1) {
        return pccPatientsMatchingLastName[0]
      }
      return null // default case
    },
    closeAssignPccPatientMatchDialog() {
      this.showAssignPccPatientMatchDialog = false
    },
    openAssignPccPatientMatchDialogIfSuggested() {
      this.showAssignPccPatientMatchDialog = true
    },
    confirmAssignPatientAction() {
      let pccPatient = this.suggestedPccPatient()
      this.patient.pccPatientId = pccPatient && pccPatient.pccPatientId
    },
    save(): void {
      if (!this.patient.mainCareGiver) {
        this.errorMessage = 'Main Caregiver is required.'
        this.error = true
        return
      }
      this.error = false
      this.saving = true
      updatePatientQuery(this.patient as FlatDetailedPatient)
        .then(() => {
          this.$router.push({ name: 'detailed-patient', params: { patient_id: this.patientId } })
        })
        .catch((error: any) => {
          this.errorMessage = 'Failed to update.'
          this.error = true
          console.log('Patient Update error', error)
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
})
